import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImgHandler {
  constructor(private http: HttpClient) {}

  /**
   * Fetch the file from the given image URL.
   */
  getFileFromUrl(imageUrl: string): Observable<File> {
    return this.http.get(imageUrl, { responseType: 'blob' }).pipe(
      map(blob => {
        const fileName = this.extractFileName(imageUrl);
        return new File([blob], fileName, { type: blob.type });
      }),
      catchError(error => {
        console.error('Error fetching file:', error);
        return throwError(() => new Error('Failed to fetch the file from the provided URL.'));
      })
    );
  }

  /**
   * Extract the file type (MIME type) from the File object.
   */
  getFileType(file: File): string {
    return file.type || 'unknown';
  }

  /**
   * Extract the file name from the URL or File object.
   */
  getFileName(file: File): string {
    return file.name;
  }

  /**
   * Extract the file name from a URL.
   */
  private extractFileName(url: string): string {
    const lastSegment = url.substring(url.lastIndexOf('/') + 1);
    return lastSegment || 'unknown-file';
  }
}
